<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-40 border-b-8 border-a-black-080909 font-text" v-if="serialModel != null">
                    <SerialDetail :serialModel="serialModel" :lbl="lbl" :value="value" :blobConfig="blobConifg"></SerialDetail>
                    <div class="h-content">
                        <Serial :serialModel="serialModel" :lbl="lbl" ref="serial" :blobConfig="blobConifg"></Serial>
                        <SerialTimer ref="elSerialTimer" :serialModel="serialModel" @onSerialExpired="onSerialExpired()" :lbl="lbl" :blobConfig="blobConifg"></SerialTimer>
                        <div class="text-center pt-1 pb-5 text-a-gray-aaaaaa">
                            {{getRedeemMessage()}}
                        </div>
                        <div >
                            <Conditions :campaign="Campaign" :lbl="lbl" :blobConifg="blobConifg"></Conditions>
                        </div>
                    </div>
                    <div class="text-center pt-3 px-4">
                        <button class="font-semiBold text-center text-16 text-a-black-080909 py-5 border border-a-black-080909 w-full rounded-40" @click="clickClose()">{{lbl.serial.close_btn}}</button>
                        <div class=" flex justify-center py-5">
                            <img class="h-5" src="../../../assets/Logo-Bzbs-black.svg"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import { defineComponent, inject, onMounted, ref } from "vue";
import { io } from "socket.io-client"; //npm i socket.io-client (https://www.npmjs.com/package/socket.io-client)
// import DatetimeHelper from "@/helper/DatetimeHelper.js";
// import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import SerialDetail from "./component/SerialDetail.vue";
import Serial from "./component/Serial.vue";
import SerialTimer from "./component/SerialTimer.vue";
import Conditions from "./component/Condition.vue"

import { PaymentQRCodeSocketModel } from "@/module/PayWithPoint/model/PaymentQrModel.js";

import { DateTime } from "luxon";
import ConfigManager from "@/config/ConfigManager";

export default defineComponent({
    name: "SerialModal",
    // mixins: [LocaleMixin],
    components: {
        SerialDetail,
        Serial,
        SerialTimer,
        Conditions
    },
    props: {
        controller: Object,
    },
    setup: function () {
        const { lbl, localeCode } = inject("LocaleStore")
        const elSerialTimer = ref(null)
        // Socket io
        // const socketUrl = ConfigManager.getWebSocketUrl()
        // const socketUrlTest = 'http://localhost:3000'
        
        // const socket = io(socketUrl, {
        //         transports: ['websocket'],
        //         upgrade: false, 
        //     });
        // const isConnected = ref(false)

        onMounted(() => {
            })

        return {
            lbl,
            localeCode,
            elSerialTimer,
            // socket,
            // isConnected
        }
    },
    data: function() {
        return {
            open: false,
            busModal: null,
            isUserActive: true,
            created_date: null,
            serialModel: null,
            Campaign: null,
            socket: null
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);

    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        checkUserActive() {
            this.isUserActive = !document.hidden;
                if(!this.isUserActive){
                    this.$refs['elSerialTimer'].onStopTime();
                }else{
                    this.$refs['elSerialTimer'].setTimeout()
                }
        },
        socketQrPayment() {
                this.socket = io(ConfigManager.getWebSocketUrl() + '/qrpaymentpwp', {
                    transports: ['websocket'],
                    upgrade: false, 
                });
                this.socket.on('disconnect', function (err) { 
                    //console.log('disconnect network', err)
                    let statusText = "disconnect network " + err
                    console.log(statusText)
                    this.isConnected = false
                });
                this.socket.on('connect_error', function (err) { 
                    //console.log('connect error' , err) 
                    let statusText =  "connect error " + err
                    console.log(statusText)
                    this.isConnected = false
                    this.socket.disconnect();
                });
                this.socket.on("connect", () => {
                    //console.log(socket.id);
                    this.isConnected = true
                    let statusText =  "connect network " + this.socket.id
                    console.log(statusText)
                    //resolve(true)
                });
                this.socket.on('qr_payment_pwp', (data) => {
                    const qrCodeModel = new PaymentQRCodeSocketModel().setDataFromApi(data)

                    if (this.serialModel.referenceQrId == qrCodeModel.referenceQrId) {
                        if(qrCodeModel.status == "SUCCESS"){
                            // Check if referenceQrid is match
                            this.controller.sendScanSuccess(qrCodeModel);
                            this.socket.disconnect();
                            this.hide(); 
                        }else{
                            this.controller.sendScanError(qrCodeModel);
                            this.socket.disconnect()
                            this.hide(); 
                        }
                    }
                })  
        },
        show: function(config) {
            //add event check user on screen or not
            document.addEventListener('visibilitychange', this.checkUserActive, false);
            // Call socket io
            this.socketQrPayment()

            this.created_date = DateTime.local();
            this.serialModel = config.serialModel;
            this.blobConifg = config.states;
            this.Campaign = this.blobConifg.campaign;
            this.value = config.value

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            // Remove event listener and clear used data
            document.removeEventListener('visibilitychange', this.checkUserActive, false);
            this.isUserActive = true;
            this.created_date = null;
            // Disabled socket io on hide
            this.socket.disconnect()

            this.$refs['elSerialTimer'].onStopTime();
            this.open = false;
        },
        clickClose: function() {
            this.hide();
            this.controller.sendCloseModal();
        },

        getRedeemMessage: function () {
            if(this.created_date == null)  return "";
            let dateStr = this.created_date.toFormat('dd/MM/yy');
            return Util.stringFormat(this.lbl.serial.redeem_on, dateStr);
        },

        onSerialExpired: function() {
            this.$refs['serial'].setSerialExpire();
            this.controller.sendSerialExpire();
        },
    },
})
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    @import '../../../style/base.scss';

    .font-text {
        font-family: $ff-text;
    }
    .font-Medium {
        font-family: $ff-Medium;
    }
    .font-semiBold {
        font-family: $ff-semi;
    }

    .modal {
        @extend %modal;
        .modal-content {
            width: 100%;
            height: 100%;
            padding: 70px 20px 20px;

            @include mobile {
                max-width: 414px;
            }

            @include min-tablet {
                max-width: 550px;
            }
        }
    }
    .h-content {
        height: 100%;
        min-height: 300px;
        max-height: 450px;
        overflow: auto;
    }
</style>
